var actual_ID;

(function (global, factory) {
  typeof exports === "object" && typeof module !== "undefined"
    ? factory(exports)
    : typeof define === "function" && define.amd
    ? define(["exports"], factory)
    : ((global = global || self), factory((global.cc_api = {})));
})(this, function (exports) {
  "use strict";

  async function getCollectionPart(index) {
    const urlparts = window.location.pathname.split("/");
    const filterPart = urlparts[urlparts.length - 1];
    return filterPart;
  }

  /**
   *
   * @param {*} url
   * @param {*} data
   */
  async function getData(url = "", data = {}) {
    //////console.log('getData');
    // Default options are marked with *
    const response = await fetch(url, {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      //   body: JSON.stringify(data) // body data type must match "Content-Type" header
    });
    return response.json(); // parses JSON response into native JavaScript objects
  }

  /**
   *
   * @param {*} brand
   */

  async function getModels(brand, q = null) {
    //////console.log('getModels');

    if (brand) {
      let url = new URL(window.location.href);
      url.pathname = "/search";
      url.searchParams.set("q", `${q ? `${q}+` : ``}brand_${brand}`);
      url.searchParams.set("view", "brands");
      const result = await getData(url.toString().replace("%2B", "+"));
      return result;
    }
  }

  /**
   *
   * @param {*} selected
   */
  function getSelected(selected) {
    return selected ? 'checked="true"' : "";
  }

  function hasWhiteSpace(s) {
    return s.indexOf(" ") >= 0;
  }

  /**
   *
   * @param {*} data
   * @param {*} selected
   *
   *
   */

  function isSelected(data, selected) {
    if (hasWhiteSpace(data)) {
      data = data.split(" ").join("-");
    }

    if (data == selected) {
      return true;
    } else {
      return false;
    }
  }

  function currentCollection() {
    var newUrl = new URL(window.location.href);
    var current = newUrl.pathname
      .replace(`${window.collectionRoute}/`, "")
      .split("/")[0];
    return current; //fullurl.split('/')[4];
  }

  function mapFiltersHelper(model) {
    return model.split(" ").join("-");
  }

  /**
   *
   * @param {*} models
   * @param {*} selectedModels
   */

  function mapFilters(models, selectedModels, brand) {
    return `
${Object.keys(models)
  .map(
    (key) =>
      `<li class="inactive-tag-link">
<label for="model_${mapFiltersHelper(models[key])}">
<span class="filter-checkbox"> <input class="filter_checkbox" ${getSelected(
        isSelected(models[key], selectedModels)
      )} type="checkbox" id="model_${mapFiltersHelper(
        models[key]
      )}" name="model" value="${
        models[key]
      }"> <span class="filter-checkbox-click"></span> </span>
<span class="filter-tag"><a href="/collections/${currentCollection()}/${brand}+${mapFiltersHelper(
        models[key]
      )}" title="Narrow selection to products matching model ${mapFiltersHelper(
        models[key]
      )}">${models[key].toUpperCase()}</a> </span>
</label>
${
  window.ShopifyAnalytics.meta.page.customerId
    ? `<svg class="addFav" data-brand="${brand}" data-model="${models[key]}"version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
width="15px" height="15px" viewBox="0 0 15 15" style="enable-background:new 0 0 15 15;" xml:space="preserve">
<path d="M13.91,6.75c-1.17,2.25-4.3,5.31-6.07,6.94c-0.1903,0.1718-0.4797,0.1718-0.67,0C5.39,12.06,2.26,9,1.09,6.75
C-1.48,1.8,5-1.5,7.5,3.45C10-1.5,16.48,1.8,13.91,6.75z"/>
</svg>`
    : ``
}
</li>`
  )
  .join("")}
`;
  }

  function setStorage(key, value, ttl = 1000 * 60 * 60 * 24 * 30) {
    //////console.log('setStorage');

    const now = new Date();

    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
  }
  function getStorage(key) {
    //////console.log('getStorage');

    const itemStr = localStorage.getItem(key);
    // if the item doesn't exist, return null
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  }

  /**
   *
   * @param {*} url
   * @param {*} data
   */
  async function postData(url = "", data = {}) {
    //////console.log('postData');

    // Default options are marked with *
    const response = await fetch(url, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(data), // body data type must match "Content-Type" header
    });
    return response.json(); // parses JSON response into native JavaScript objects
  }

  var apiBase =
    "https://us-central1-cartouches-certifies.cloudfunctions.net/api/v1";

  /**
   *
   * @param {*} customer
   */

  async function getFavs(customer, new_ID) {
    //console.log('getFavs');

    var reset = false;

    if (new_ID != null) {
      if (new_ID) {
        reset = true;
      }
    }

    if (customer) {
      if (reset) {
        localStorage.setItem("favourites", "[]");

        /*
        localStorage.setItem("customer_id", "");

        localStorage.setItem("customer_email", "");

        localStorage.setItem("customer_phone", "");
        */
      }

      let favourites = getStorage("favourites");

      if (favourites) {
        return favourites;
      } else {
        const result = await getData(apiBase + "/favourites/" + customer);

        if (result.error != null) {
          setStorage("new_client", true);
        } else {
          setStorage("new_client", false);
        }

        setStorage("favourites", result.favourites);

        setStorage("customer_id", result.customerID);

        setStorage("customer_email", result.email);

        setStorage("customer_phone", result.phone);

        return result.favourites;
      }
    } else {
      //console.error("You need an ID");
    }
  }

  function mapFavsHelper(fav) {
    //////console.log('mapFavsHelper');

    return fav.split(" ").join("-");
  }

  function mapFavourites(favs, collectionRoot) {
    //////console.log('mapFavourites');

    // Now sort this markup
    return `
${Object.keys(favs)
  .map(
    (key) =>
      `<li class="inactive-tag-link">
<label for="${favs[key].model}">

<span class="filter-tag"><a href="${collectionRoot}/all/${
        favs[key].brand
      }+${mapFavsHelper(favs[key].model)}" data-currentFav="${mapFavsHelper(
        favs[key].model
      )}" title="Narrow selection to products matching ${favs[key].brand} ${
        favs[key].model
      }">${favs[key].brand} ${favs[
        key
      ].model.toUpperCase()}</a> <span class="filter-tag-count"></span> </span>
</label>
<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" width="15" height="15" class="delFav" data-brand="${
        favs[key].brand
      }" data-model="${
        favs[key].model
      }"><defs><style>.cls-1{fill:none;}</style></defs><title/><g data-name="Layer 2" id="Layer_2"><path d="M20,29H12a5,5,0,0,1-5-5V12a1,1,0,0,1,2,0V24a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V12a1,1,0,0,1,2,0V24A5,5,0,0,1,20,29Z"/><path d="M26,9H6A1,1,0,0,1,6,7H26a1,1,0,0,1,0,2Z"/><path d="M20,9H12a1,1,0,0,1-1-1V6a3,3,0,0,1,3-3h4a3,3,0,0,1,3,3V8A1,1,0,0,1,20,9ZM13,7h6V6a1,1,0,0,0-1-1H14a1,1,0,0,0-1,1Z"/><path d="M14,23a1,1,0,0,1-1-1V15a1,1,0,0,1,2,0v7A1,1,0,0,1,14,23Z"/><path d="M18,23a1,1,0,0,1-1-1V15a1,1,0,0,1,2,0v7A1,1,0,0,1,18,23Z"/></g><g id="frame"><rect class="cls-1" height="32" width="32"/></g></svg>
</li>`
  )
  .join("")}
`;
  }

  async function delData(url = "", data = {}) {
    //////console.log('delData');

    // Default options are marked with *
    const response = await fetch(url, {
      method: "DELETE", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      //   body: JSON.stringify(data) // body data type must match "Content-Type" header
      body: JSON.stringify(data), // body data type must match "Content-Type" header
    });
    return response.json(); // parses JSON response into native JavaScript objects
  }

  /**
   *
   * @param {*} customer
   * @param {*} id
   */

  async function delFav(customer, brand, model) {
    if (brand && model) {
      $("body").addClass("body_dot-loading");
      $(".dot-test").css("display", "block");
      let result = await delData(apiBase + "/favourites/" + customer, {
        customerID: customer,
        favourites: [
          {
            brand: brand,
            model: model,
          },
        ],
      });
      const modelV1 = model.replace("printer_", "").replace(/-/g, " ");
      const modelRegex = new RegExp(modelV1.replace(/\s+/g, "[\\s-]*"), "i");

      if (
        result.favourites.some((item) =>
          modelRegex.test(item.model.replace(/\s+/g, ""))
        )
      ) {
        result = await delData(apiBase + "/favourites/" + customer, {
          customerID: customer,
          favourites: result.favourites.filter((item) =>
            modelRegex.test(item.model.replace(/\s+/g, ""))
          ),
        });
      }
      if ($("#shopify-section-wishlist-template").length > 0) {
        getFavs(customer);
      }
      setStorage("favourites", result.favourites);
      if (window.location.href.includes("/pages/my-wishlist")) {
        await displayFavouritesInit(customer, result.favourites);
      }
      $("body").removeClass("body_dot-loading");
      $(".dot-test").css("display", "none");
      return result.favourites;
    }
  }

  function fillSVG(t, colour) {
    //////console.log('fillSVG');

    t.setAttribute("fill", colour);
  }

  function rafAsync() {
    ////////console.log('rafAsync');

    return new Promise((resolve) => {
      requestAnimationFrame(resolve); //faster than set time out
    });
  }

  function checkElement(selector) {
    ////////console.log('checkElement');

    if (document.querySelector(selector) === null) {
      return rafAsync().then(() => checkElement(selector));
    } else {
      return Promise.resolve(true);
    }
  }

  function removeFillSVG(d) {
    //////console.log('removeFillSVG');

    checkElement("svg.addFav") //use whichever selector you want
      .then((element) => {
        document.querySelectorAll("svg.addFav").forEach((t) => {
          let dModel1 = t.getAttribute("data-model");
          if (d === dModel1) {
            fillSVG(t, "white");
          }
        });
      });
  }

  var clicked = "";
  async function displayFavouritesInit(customer, favs = null) {
    var customer_id_string = customer.toString();
    var new_ID = false;
    if (customer != actual_ID) {
      new_ID = true;
    }
    actual_ID = customer;
    favs = favs || (await getFavs(customer, new_ID));

    const cartouchesItems = document.querySelectorAll(
      ".wishlist-items_cartouches > *"
    );
    if (cartouchesItems) {
      cartouchesItems.forEach((element) => (element.innerHTML = ""));
    }

    const printersContainer = document.querySelector(
      ".wishlist-items_printers"
    );
    if (printersContainer) {
      printersContainer.innerHTML = "";
    }

    const sidebarElements = document.querySelector(
      ".wishlist-sidebar-elements"
    );
    if (sidebarElements) {
      sidebarElements.innerHTML = "";
    }

    if (document.querySelector(".wishlist-items")) {
      document.querySelector(".wishlist-items").classList.add("wishlist-none");

      document
        .querySelector(".wishlist-items-cartouches_container")
        ?.classList.add("wishlist-cartouches_none");

      document
        .querySelector(".wishlist-items-printers_container")
        ?.classList.add("wishlist-printers_none");

      if (favs) {
        const sorted = favs.sort(function (a, b) {
          if (a.brand.localeCompare(b.brand) === 0) {
            return a.model.localeCompare(b.model);
          } else {
            return a.brand.localeCompare(b.brand);
          }
        });

        var fav_title = "";
        if (location.hostname.indexOf("cartouchescertifiees") !== -1) {
          fav_title = "Cartouches favorites par imprimantes";
        }
        if (location.hostname.indexOf("certifiedcartridges") !== -1) {
          fav_title = "Favourite cartridges by printer";
        }

        var count = 0;
        var count_cartouches = 0;
        var count_printers = 0;
        var max = sorted.length;

        if (document.querySelector(".wishlist-items")) {
          const sidebarContainer = document.querySelector(
            ".wishlist-sidebar-container"
          );
          if (sidebarContainer) {
            sidebarContainer.style.display = "none";
          }

          try {
            await Promise.all(
              sorted.map(async (item) => {
                let type = item.model.split("_")[0];
                let model = item.model.split("_")[1];
                const brand = item.brand;
                let isProduct = type === "cartouches" || type === "product";
                let isPrinterCompatible = type === "printer";

                if (!model) {
                  model = item.model;
                  const q = `printer-${item.brand.toLowerCase()}-${item.model
                    .toLowerCase()
                    .replace(/\s+/g, "-")}`;
                  const x = await fetch(
                    `/search?type=product&options%5bunavailable_products%5d=last&options%5bprefix%5d=none&q=${q}*&view=json`
                  );
                  const response = await x.json();
                  const productFound =
                    Array.isArray(response) &&
                    response.some((item) => item.handle === q);

                  if (productFound) {
                    isPrinterCompatible = true;
                    isProduct = false;
                    type = "printer";
                  }

                  if (response.length === 0) {
                    isProduct = true;
                    isPrinterCompatible = false;
                    type = "cartouches";
                  }
                }

                const is_unboxed = model.indexOf("unboxed") >= 0;
                const is_compatible = model.indexOf("compatible") >= 0;
                const is_original =
                  model.indexOf("original") >= 0 ||
                  model.indexOf("originale") >= 0;
                const is_recycled =
                  model.indexOf("recycled") >= 0 ||
                  model.indexOf("refurbished") >= 0;
                const is_other =
                  !is_unboxed && !is_compatible && !is_original && !is_recycled;

                const query =
                  type !== "printer"
                    ? `${model}%20*`
                    : `${brand}%20${model.replace(/ /g, "%20").replace(/-/g, "%20")}*`;

                const slug_js =
                  type === "printer" ? "&view=compatibles" : "&view=test";
                const data =
                  `type=product&options%5bunavailable_products%5d=last&options%5bprefix%5d=none&q=${query}`
                    .replace("printer", "")
                    .replace("imprimante", "")
                    .replace("e%20all%20in%20one", "e-all-in-one")
                    .replace(/%20/g, " ");

                try {
                  const result = await fetch(`/search?${data}${slug_js}`);
                  const arr = (await result.text()).split("||");

                  if (isProduct) {
                    const cartouchesContainer = document.querySelector(
                      ".wishlist-items .wishlist-items_cartouches"
                    );

                    if (cartouchesContainer) {
                      const cartouchesTypes = [
                        "original",
                        "unboxed",
                        "compatible",
                        "recycled",
                        "other",
                      ];

                      if (
                        is_unboxed ||
                        is_compatible ||
                        is_original ||
                        is_recycled ||
                        is_other
                      ) {
                        count_cartouches += 1;

                        cartouchesTypes.forEach((type) => {
                          if (eval(`is_${type}`)) {
                            const cartouchesTypeContainer =
                              cartouchesContainer.querySelector(
                                `.cartouches_${type}`
                              );
                            if (cartouchesTypeContainer) {
                              cartouchesTypeContainer.insertAdjacentHTML(
                                "beforeend",
                                arr[1]
                              );
                            }
                          }
                        });

                        if (
                          count_cartouches > 0 &&
                          cartouchesContainer.classList.contains(
                            "wishlist-cartouches_none"
                          )
                        ) {
                          cartouchesContainer.classList.remove(
                            "wishlist-cartouches_none"
                          );
                        }
                      }
                    }
                  } else if (isPrinterCompatible) {
                    count_printers += 1;
                    const printersContainer = document.querySelector(
                      ".wishlist-items .wishlist-items_printers"
                    );
                    if (printersContainer) {
                      const printerId = `printer_${model.replace(/\s+/g, "-")}`;
                      const brandSlug = item.brand.replace(" ", "-");
                      const modelSlug = model
                        .replace(`${brandSlug}-`, "")
                        .replace(/\W+/g, " ")
                        .replace(/[^a-z0-9\s]/gi, " ");
                      /*
                      



                      document
                        .querySelector(".wishlist-sidebar-elements")
                        .insertAdjacentHTML(
                          "beforeend",
                          `<p class="wishlist-sidebar-element" data-link="${printerId}">${item.brand} ${modelSlug}</p>`
                        );
*/
                      // Fonction pour créer un élément wishlist-sidebar-element avec l'écouteur d'événement attaché
                      function createWishlistElement(
                        printerId,
                        brand,
                        modelSlug
                      ) {
                        const wishlistElement = document.createElement("label");
                        const wishlistElementInput = document.createElement("input");
                        const wishlistElementTitle = document.createElement("span");

                        wishlistElement.classList.add(
                          "wishlist-sidebar-element"
                        );
                        wishlistElement.setAttribute("data-link", printerId);
                        wishlistElement.setAttribute("for", "wish-" + printerId);
                        wishlistElement.setAttribute("data-brand", item.brand)
                        wishlistElement.setAttribute("data-model", printerId)
                        wishlistElement.setAttribute("model-slug", modelSlug)

                        wishlistElementTitle.textContent = `${brand} ${modelSlug}`;

                        wishlistElementInput.setAttribute("type", "checkbox");
                        wishlistElementInput.setAttribute("id", "wish-" + printerId);
                        wishlistElementInput.setAttribute("name", "wish-" + printerId);

                        wishlistElement.append(wishlistElementInput)
                        wishlistElement.append(wishlistElementTitle)

                        wishlistElementInput.addEventListener("change", function (e) {
                          const checkedInputs = document.querySelectorAll(
                            '.wishlist-sidebar-element input[type="checkbox"]:checked'
                          );
                          document
                            .querySelectorAll(".wishlist-sidebar-element")
                            .forEach(function (element) {
                              element.style.backgroundColor = "";
                              element.style.color = "";
                            });
                            printersContainer.innerHTML = "";

                          checkedInputs.forEach(function (checkedInput) {
                            const label = checkedInput.closest("label");
                            const data_brand = label.getAttribute("data-brand")
                            const data_model = label.getAttribute("data-model")
                            const model_slug = label.getAttribute("model-slug")
                            label.style.backgroundColor = "#9ba84e";
                            label.style.color = "white";
                            printersContainer.insertAdjacentHTML("beforeend",`<div id="${data_model}"></div>`)

                            const printerHeading = `
                            <div class="only-for-cartouches-compatibles">
                              <div class="wishlist-heart">
                                <div class="addFav_container">
                                  <svg class="addFav" style="float:none;" data-brand="${data_brand}" data-model="${data_model}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30px" height="30px" fill="red" stroke="black" viewBox="0 0 15 15" style="enable-background:new 0 0 15 15;" xml:space="preserve">
                                    <path d="M13.91,6.75c-1.17,2.25-4.3,5.31-6.07,6.94c-0.1903,0.1718-0.4797,0.1718-0.67,0C5.39,12.06,2.26,9,1.09,6.75C-1.48,1.8,5-1.5,7.5,3.45C10-1.5,16.48,1.8,13.91,6.75z"/>
                                  </svg>
                                </div>
                              </div>
                              <h3 class="printer_name">${data_brand.replace("-"," ")} ${model_slug} :</h3>
                            </div>`;
                            const printerContainerElement = document.getElementById(data_model); // Utilisez document.getElementById() directement
                            printerContainerElement.insertAdjacentHTML("beforeend", printerHeading);
                            printerContainerElement.insertAdjacentHTML("beforeend", arr[1]);
  
                            if (printersContainer.classList.contains("wishlist-printers_none")) {
                              printersContainer.classList.remove("wishlist-printers_none");
                            }
  
                            document
                              .querySelector(".wishlist-items-printers_container")
                              ?.classList.remove("wishlist-printers_none");
  
                            listen(customer);
                            productPageFavs();
                            clicked = data_model;
                          });

                          var add_height = 0;
                          const label = this.parentNode;
                          const data_link = label.getAttribute("data-link");

                          const target = this.checked ? "#" + data_link : printersContainer.children.length ? ".wishlist-items_printers" : ".wishlist-items-cartouches_container";
                          if ($(window).scrollTop() > $(target).offset().top) {
                            add_height += $('#shopify-section-header_8').height();
                          }

                          const title = document.querySelector('.wishlist-sidebar .widget-title');
                          const elements = document.querySelector('.wishlist-sidebar-elements');
                          const svg = title.querySelector('svg');
                          
                          
                          add_height += $('.popup_info_log').length ? $('.popup_info_log').height() : 10;
                          if(this.checked) {
                            console.log("check")
                            if (window.innerWidth < 768) {
        
                              add_height += $('.wishlist-sidebar-container').length ? $('.wishlist-sidebar-container').height() : 0;
                            }
                            console.log($(target).offset().top - add_height)
                            $([document.documentElement, document.body]).animate({
                              scrollTop: $(target).offset().top - add_height
                            }, 1000);
                          } else {
                            console.log("uncheck")
                            
                            $([document.documentElement, document.body]).animate({
                              scrollTop: $('.wishlist-all-items').offset().top - add_height
                            }, 2000);
                            }
                            if (window.innerWidth < 768) {
                            
                              elements.classList.remove('open');
                              svg.classList.remove('rotated');
                            }
                        });
                        
                        
                        /*
                        wishlistElement.addEventListener("click", function () {
                          console.log("Click");
                          this.parentNode.querySelectorAll(".wishlist-sidebar-element").forEach(function(sibling) {
                              sibling.style.backgroundColor = ""; // Rétablir l'arrière-plan par défaut
                              sibling.style.color = ""; // Rétablir la couleur de texte par défaut
                          });
                      
                          // Mettre en surbrillance l'élément cliqué
                          this.style.backgroundColor = "#9ba84e";
                          this.style.color = "white";
                          printersContainer.innerHTML = "";
                          printersContainer.insertAdjacentHTML(
                            "beforeend",
                            `<div id="${printerId}"></div>`
                          );
                          const printerHeading = `
                          <div class="only-for-cartouches-compatibles">
                            <div class="wishlist-heart">
                              <div class="addFav_container">
                                <svg class="addFav" style="float:none;" data-brand="${item.brand}" data-model="${printerId}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30px" height="30px" fill="red" stroke="black" viewBox="0 0 15 15" style="enable-background:new 0 0 15 15;" xml:space="preserve">
                                  <path d="M13.91,6.75c-1.17,2.25-4.3,5.31-6.07,6.94c-0.1903,0.1718-0.4797,0.1718-0.67,0C5.39,12.06,2.26,9,1.09,6.75C-1.48,1.8,5-1.5,7.5,3.45C10-1.5,16.48,1.8,13.91,6.75z"/>
                                </svg>
                              </div>
                            </div>
                            <h3 class="printer_name">${item.brand.replace("-"," ")} ${modelSlug} :</h3>
                          </div>`;

                          document
                            .getElementById(printerId)
                            .insertAdjacentHTML("beforeend", printerHeading);
                          document
                            .getElementById(printerId)
                            .insertAdjacentHTML("beforeend", arr[1]);

                          if (printersContainer.classList.contains("wishlist-printers_none")) {
                            printersContainer.classList.remove("wishlist-printers_none");
                          }

                          document
                            .querySelector(".wishlist-items-printers_container")
                            ?.classList.remove("wishlist-printers_none");

                          listen(customer);
                          productPageFavs();
                          clicked = printerId;

                        });
                        */
                        return wishlistElement;
                      }

                      // Sélection de l'élément conteneur de la liste de souhaits
                      const wishlistContainer = document.querySelector(
                        ".wishlist-sidebar-elements"
                      );

                      // Création de l'élément wishlist-sidebar-element
                      const newWishlistElement = createWishlistElement(
                        printerId,
                        item.brand,
                        modelSlug
                      );

                      // Ajout de l'élément à la liste de souhaits
                      wishlistContainer.appendChild(newWishlistElement);

                      if (clicked === printerId) {
                        newWishlistElement.click(); // Simuler un clic sur l'élément
                      }
                    }
                  }
                  count += 1;
                } catch (error) {
                  console.error("Error processing product:", error);
                } finally {
                  document.body.classList.remove("body_dot-loading");
                  document.querySelector(".dot-test").style.display = "none";
                }
              })
            );
          } catch (error) {
            console.error(
              "Une erreur s'est produite lors de l'affichage des favoris :",
              error
            );
          }

          if (count_cartouches > 0) {
            document
              .querySelector(".wishlist-items-cartouches_container")
              ?.classList.remove("wishlist-cartouches_none");
          } else {
            document
              .querySelector(".wishlist-items-cartouches_container")
              ?.classList.add("wishlist-cartouches_none");
          }
          /*
          
          */

          if (count_cartouches === 0 && count_printers === 0) {
            document
              .querySelector(".wishlist-items")
              ?.classList.add("wishlist-void");
          } else {
            document
              .querySelector(".wishlist-items")
              ?.classList.remove("wishlist-void");
          }

          document
            .querySelector(".wishlist-items")
            ?.classList.remove("wishlist-none");

          if (sidebarContainer) {
            sidebarContainer.style.display = "block";
          }
        } else {
          document
            .querySelector(".wishlist-items")
            ?.classList.add("wishlist-void");
        }
      }
    }

    listen(customer);
    productPageFavs();
    handleScrollBehavior();
    return true;
  }

  function handleScrollBehavior() {

const title = document.querySelector('.wishlist-sidebar .widget-title');
const elements = document.querySelector('.wishlist-sidebar-elements');
const svg = title?.querySelector('svg');

if (title && elements && svg) {
    title.addEventListener('click', function () {
        const isOpen = elements.classList.contains('open');
        elements.classList.toggle('open', !isOpen);
        svg.classList.toggle('rotated', !isOpen);
    });
}
    
      var body = document.querySelector("body");

  var ntheader = document.querySelector("#ntheader");
  var popupInfoLog = document.querySelector(".popup_info_log");
  var wishlistSidebarContainer = document.querySelector(".wishlist-sidebar-container");
  


  window.addEventListener("scroll", function() {
      var scrollTop = window.scrollY;
      if (ntheader.classList.contains("h_scroll_down")) {
          // Calculer la hauteur de .wishlist-sidebar-container en fonction de .popup_info_log
          var topValue = popupInfoLog ? popupInfoLog.offsetHeight : 0;
          wishlistSidebarContainer.style.top = topValue + "px";
                  wishlistSidebarContainer.style.top = topValue + "px";

      } else if (ntheader.classList.contains("h_scroll_up")) {
          // Calculer la hauteur de .wishlist-sidebar-container en fonction de #ntheader et .popup_info_log
          var topValue = ntheader.offsetHeight ;
          wishlistSidebarContainer.style.top = topValue + "px";

            if (window.innerWidth < 768) {
            body.style.marginTop = topValue + "px"; // Ajouter la marge supérieure

                  popupInfoLog.style.height = topValue + "px";
            }

      }
  });
}
      
  
  /**
   *
   * @param {*} customer
   * @param {*} id
   */

  async function addFav(customer, brand, model) {
    //////console.log('addFav');

    //console.log("Adding", customer, brand, model);
    if (brand && model) {
      $("body").addClass("body_dot-loading");
      $(".dot-test").css("display", "block");

      const result = await postData(apiBase + "/favourites/" + customer, {
        customerID: customer,
        favourites: [
          {
            brand: brand,
            model: model,
          },
        ],
      });

      if ($("#shopify-section-wishlist-template").length > 0) {
        getFavs(customer);
      }

      setStorage("favourites", result.favourites);
      //console.log(result.favourites);

      if (window.location.href.includes("/pages/my-wishlist")) {
        await displayFavouritesInit(customer, result.favourites);
      }
      $("body").removeClass("body_dot-loading");
      $(".dot-test").css("display", "none");

      return result.favourites;
    } else {
      //console.error("You need an ID");
    }
  }

  function favHeartInit(customer, t) {
    //console.log('favHeartInit');

    if (t.getAttribute("fill") == "red") {
      fillSVG(t, "white");
      delFav(
        customer,
        t.getAttribute("data-brand"),
        t.getAttribute("data-model")
      );
    } else {
      fillSVG(t, "red");
      addFav(
        customer,
        t.getAttribute("data-brand"),
        t.getAttribute("data-model")
      );
    }
  }

  function listen(customer) {
    //console.log("listen");
    ////////console.log($('.compatibles-items').length);
    if ($(".compatibles-items").length) {
      var checkExist = setInterval(function () {
        if ($(".wishlist-item").length) {
          clearInterval(checkExist);

          document.querySelectorAll("svg.addFav").forEach((t) => {
            //console.log(t);
            t.addEventListener("click", (ev) => {
              favHeartInit(customer, t);
            });
          });
        }
      }, 500); // check every 100ms
    } else {
      var checkExist = setInterval(function () {
        if ($(".addFav").length) {
          clearInterval(checkExist);

          document.querySelectorAll("svg.addFav").forEach((t) => {
            //console.log(t);

            t.addEventListener("click", (ev) => {
              favHeartInit(customer, t);
            });
          });
        }
      }, 500); // check every 100ms
    }
  }

  async function retreiveModels(brand) {
    //////console.log('retreiveModels');

    return new Promise(async (resolve) => {
      let sModels = getStorage("models") || {};
      if (sModels && sModels[brand]) {
        //////console.log("saved brands");
        resolve(sModels[brand]);
      } else {
        (async function () {
          //////console.log("fetching brands");
          let counter = 1;
          const firstResult = await fetch(
            `/search?q=brand_${brand}&view=brands&page=${counter}`
          );
          const firstData = await firstResult.json();
          const pages = Number(firstData.pages);
          ////////console.log(pages);
          const searchPromises = [];
          const sortData = firstData.models
            .map((r) => r.replace("model_", ""))
            .sort();
          const models = Object.assign({}, sortData);
          sModels[brand] = [...(sModels[brand] || []), ...sortData].sort();
          counter++;
          if (counter > pages) {
            setStorage("models", sModels);
            resolve(models);
          }
          for (let page = 2; page <= pages; page++) {
            searchPromises.push(
              fetch(`/search?q=brand_${brand}&view=brands&page=${page}`)
            );
          }
          const searchResults = await Promise.all(searchPromises);
          for await (const s of searchResults) {
            try {
              const data = await s.json();
              const sortData = data.models
                .map((r) => r.replace("model_", ""))
                .sort();
              const models = Object.assign({}, sortData);
              sModels[brand] = [...(sModels[brand] || []), ...sortData].sort();
              counter++;
              if (counter > pages) {
                setStorage("models", sModels);
                resolve(models);
              }
            } catch (e) {
              setTimeout(async () => {
                const raw = await fetch(
                  `/search?q=brand_${brand}&view=brands&page=${counter}`
                );
                const data = await s.json();
                const sortData = data.models
                  .map((r) => r.replace("model_", ""))
                  .sort();
                const models = Object.assign({}, sortData);
                sModels[brand] = [
                  ...(sModels[brand] || []),
                  ...sortData,
                ].sort();
                counter++;
                if (counter > pages) {
                  setStorage("models", sModels);
                  resolve(models);
                }
              });
            }
          }
        })();
        if (window.tempModels && window.tempModels[brand]) {
          //////console.log("Temp brands");
          resolve(window.tempModels[brand]);
        }
      }
    });
  }

  /**
   *
   * @param {*} brand
   * @param {*} selectedModels
   */

  function getModelsFilter(brand, selectedModels, jClass) {
    let myBrand = brand.split("+")[0];
    let myModel = [brand.split("+")[1]] || [];
    let brandQuery = myBrand.replace("brand_", "");
    $(jClass).html(`<span>${window.loadingString}</span>`);
    retreiveModels(brandQuery).then((models) => {
      var markup = mapFilters(models, myModel || [], brandQuery);
      if (Object.assign([], models).length > 0) {
        $(jClass).html(markup);
        if (window.ShopifyAnalytics.meta.page.customerId) {
          listen(window.ShopifyAnalytics.meta.page.customerId);
        }
      } else {
        $(jClass).html(`<span>${window.selectBrand}</span>`);
      }
    });
  }

  function split(data) {
    var filterValue = data;
    if (filterValue) {
      return filterValue.split("_")[1] || null;
    }
    return;
  }

  /**
   *
   * @param {*} v
   */

  function splitModel(v) {
    if (v && v.includes("+")) {
      var filterValue = v.split("+");
      var newFilterValue = split(filterValue[1]);
      return newFilterValue;
    }
  }

  function buildSearchURL(key, query) {
    return `${window.searchRoute}/${query}+${key.split(" ").join("-")}`;
  }

  function mapBrands(brands, resc, url1, selectedBrand) {
    //////console.log('mapBrands');

    return `
${Object.keys(brands)
  .map(
    (key) =>
      `<li class="active-tag-link">
<label for="${brands[key]}" data-query="${brands[key]}">
<span class="filter-checkbox">
<input type="checkbox" id="${brands[key]}" name="${brands[key]}" value="${
        brands[key]
      }" ${getSelected(isSelected(brands[key], selectedBrand))}>
<span class="filter-checkbox-click"></span>
</span>
<span class="filter-tag"><a href="${buildSearchURL(brands[key], url1)}">${
        brands[key]
      }</a>                                    
<span class="filter-tag-count"></span>
</span>
</label>
</li>`
  )
  .join("")}
`;
  }

  function mapBrandsCollection(brands, resc, collectionRoute, selectedBrand) {
    return `
${Object.keys(brands)
  .map(
    (key) =>
      `<li class="inactive-tag-link">
<label for="model_${mapFiltersHelper(brands[key])}">
<span class="filter-checkbox"> <input class="filter_checkbox" ${getSelected(
        isSelected(brands[key], selectedBrand)
      )} type="checkbox" id="model_${mapFiltersHelper(
        brands[key]
      )}" name="brand" value="${
        brands[key]
      }"> <span class="filter-checkbox-click"></span> </span>
<span class="filter-tag"><a href="${collectionRoute}/${currentCollection()}/${mapFiltersHelper(
        brands[key]
      )}" title="Narrow selection to products matching tag brand_${mapFiltersHelper(
        brands[key]
      )}
}">${brands[key]}</a> </span>
</label>
</li>`
  )
  .join("")}
`;
  }

  function searchUrl(models, selectedModels, brand) {
    var newUrl = new URL(window.location.href);
    var query;
    if (newUrl.search) {
      query = newUrl.searchParams.get("q");
    }
    query = query.includes(brand) ? query : `${query}+${brand}`;
    query = query.includes(models.split(" ").join("-"))
      ? query
      : `${query}+${models.split(" ").join("-")}`;
    newUrl.searchParams.set("q", query);
    return `${window.searchRoute}${newUrl.search.replace(/%2B/g, "+")}`;
    /*
var fullurl = window.location.href.toString();
var values = fullurl.split('=')[1]
var modelFilterValues = values.split('+')
var theSearch = modelFilterValues[0];
return `${window.searchRoute}?q=${theSearch}+${brand}+${models.split(" ").join("-")}"`;*/
  }

  /**
   *
   * @param {*} models
   * @param {*} selectedModels
   */

  function mapSearchFilters(models, selectedModels, brand) {
    // Now sort this markup
    return `
${Object.keys(models)
  .map(
    (key) =>
      `<li class="inactive-tag-link">
<label for="model_${models[key]}">
<span class="filter-checkbox"> <input class="filter_checkbox" ${getSelected(
        isSelected(models[key], selectedModels)
      )} type="checkbox" id="model_${models[key]}" name="model" value="${
        models[key]
      }"> <span class="filter-checkbox-click"></span> </span>
<span class="filter-tag"><a href="${searchUrl(
        models[key],
        selectedModels,
        brand.replace("brand_", "")
      )}" title="Narrow selection to products matching tag ${
        models[key]
      }">${models[
        key
      ].toUpperCase()}</a> <span class="filter-tag-count"></span> </span>
</label>
${
  window.ShopifyAnalytics.meta.page.customerId
    ? `<svg class="addFav" data-brand="${brand}" data-model="${models[key]}"version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
width="15px" height="15px" viewBox="0 0 15 15" style="enable-background:new 0 0 15 15;" xml:space="preserve">
<path d="M13.91,6.75c-1.17,2.25-4.3,5.31-6.07,6.94c-0.1903,0.1718-0.4797,0.1718-0.67,0C5.39,12.06,2.26,9,1.09,6.75
C-1.48,1.8,5-1.5,7.5,3.45C10-1.5,16.48,1.8,13.91,6.75z"/>
</svg>`
    : ``
}
</li>`
  )
  .join("")}
`;
  }

  /**
   *
   * @param {*} brand
   * @param {*} selectedModels
   */

  function getModelsFilterSearch(brand, selectedModels, jClass) {
    //////console.log('getModelsFilterSearch');

    if (brand && jClass) {
      const searchUrl = new URL(window.location.href);
      let q = null;
      if (searchUrl.pathname.includes("/search")) {
        const params = searchUrl.searchParams.get("q").split(" ");
        q = params.filter((p) => !p.includes("model_")).join(" ");
      }
      let sModels = getStorage("models") || {};
      if (
        sModels &&
        sModels[brand.replace("brand_", "")] &&
        (!q || q === "*")
      ) {
        const currentModels = searchUrl.search
          .replace("?q=", "")
          .split("+")
          .find((el) =>
            Object.assign([], sortData).find((br) =>
              br.split(" ").join("-").includes(el.split(" ").join("-"))
            )
          );
        var markup = mapSearchFilters(
          sModels[brand.replace("brand_", "")],
          currentModels,
          brand.replace("brand_", "")
        );
        $(jClass).html(markup);
      } else {
        $(jClass).html(`<span>${window.loadingString}</span>`);
        getModels(brand.replace("brand_", ""), q)
          .then((data) => {
            const sortData = data.models
              .map((r) => r.replace("model_", ""))
              .sort();
            const currentModels = searchUrl.search
              .replace("?q=", "")
              .split("+")
              .find((el) =>
                Object.assign([], sortData).find((br) =>
                  br.split(" ").join("-").includes(el.split(" ").join("-"))
                )
              );
            const models = Object.assign({}, sortData);
            var markup = mapSearchFilters(
              models,
              currentModels,
              brand.replace("brand_", "")
            );
            if (Object.assign([], models).length > 0) {
              $(jClass).html(markup);
              sModels[brand.replace("brand_", "")] = models;
              setStorage("models", sModels);
              if (window.ShopifyAnalytics.meta.page.customerId) {
                listen(window.ShopifyAnalytics.meta.page.customerId);
              }
            } else {
              $(jClass).html(`<span>${window.selectBrand}</span>`);
            }
          })
          .catch((error) => {
            //console.error(error);
          });
      }
    }
  }

  /*import { getStorage, setStorage } from "./expireStorage";

export default async function retreiveBrands (q) {
let sBrands = getStorage ("brands");
if (sBrands && (!q || q === "*")) {
const data = sBrands;
return data
} else {
const brandsRaw = await fetch(`/search?q=${q || "*"}&view=brands`);
const data = await brandsRaw.json();
if((!q || q === "*")){
  setStorage("brands", data);
}
return data;
}
}*/

  async function retreiveBrands(q) {
    //////console.log('retreiveBrands');

    return new Promise(async (resolve) => {
      let sBrands = getStorage("brands");
      if (sBrands && (!q || q === "*")) {
        resolve(sBrands);
      } else {
        sBrands = {
          brands: [],
          models: [],
        };
        const pages = Math.ceil(window.productsCount / 1000);
        //////console.log(pages);
        const searchPromises = [];
        for (let page = 1; page <= pages; page++) {
          searchPromises.push(
            fetch(`/search?q=${q || "*"}&view=brands&page=${page}`)
          );
        }
        const searchResults = await Promise.all(searchPromises);
        let counter = 1;
        for await (const s of searchResults) {
          try {
            const data = await s.json();
            sBrands = {
              ...sBrands,
              brands: Array.from(
                new Set([...sBrands.brands, ...data.brands])
              ).sort(),
              models: Array.from(
                new Set([...sBrands.models, ...data.models])
              ).sort(),
            };
            counter++;
            if (counter > pages) {
              if (!q || q === "*") {
                setStorage("brands", sBrands);
              }
              resolve(sBrands);
            }
          } catch (e) {
            setTimeout(async () => {
              try {
                const raw = await fetch(
                  `/search?q=${q || "*"}&view=brands&page=${counter}`
                );
                const data = await raw.json();
                sBrands = {
                  ...sBrands,
                  brands: Array.from(
                    new Set([...sBrands.brands, ...data.brands])
                  ).sort(),
                  models: Array.from(
                    new Set([...sBrands.models, ...data.models])
                  ).sort(),
                };
              } catch (e) {}
              counter++;
              if (counter > pages) {
                if (!q || q === "*") {
                  setStorage("brands", sBrands);
                }
                resolve(sBrands);
              }
            });
          }
        }
      }
    });
  }

  async function getBrands(q = null, preload = false) {
    let data;
    let query = q ? q : "*";
    data = preload ? window.tempBrands.brands : await retreiveBrands(query);
    const sortData = data.brands.map((r) => r.replace("brand_", "")).sort();
    const brands = Object.assign({}, sortData);
    var url = window.location.href;
    var newurl = new URL(url);
    var urlSearch = newurl.search;
    var urlSearch2 = urlSearch.split("+");
    var searchToString = urlSearch2.toString();
    var resc = searchToString.replace(",", "+");
    var collectionSelected = url.split("/")[url.split("/").length - 1];
    var collectionBrand = collectionSelected.split("+")[0];
    var collectionModel = collectionSelected.split("+")[1];

    if (urlSearch2[1] !== undefined) {
      var selectedBrand = urlSearch
        .replace("?q=", "")
        .split("+")
        .find((el) => sortData.find((br) => br.includes(el)));
      var selectedModelSearch = split(urlSearch2[2]);
      var markup2 = mapBrands(brands, resc, urlSearch2[0], selectedBrand);
      $(".brand_search").html(markup2);
      if (urlSearch2[2] != undefined) {
        getModelsFilterSearch(
          selectedBrand,
          selectedModelSearch,
          ".model_search"
        );
      } else {
        getModelsFilterSearch(selectedBrand, "dcp-12009999", ".model_search");
      }
    } else {
      var markupCollection = mapBrandsCollection(
        brands,
        resc,
        window.collectionRoute,
        collectionBrand
      );
      var markup = mapBrands(brands, resc, urlSearch2[0], selectedBrand);
      $(".sidebar-filter-nav.brand").html(markupCollection);
      $(".sidebar-filter-nav.model")
        .empty()
        .append(`<span>${window.selectBrand}</span>`);
      $(".brand_search").html(markup);
      $(".model_search").empty().append(`<span>${window.selectBrand}</span>`);
    }
  }

  /**
   *
   */

  function collectionFilterInit() {
    //////console.log('collectionFilterInit');

    $(document).ready(function () {
      getBrands();
      getCollectionPart().then((v) => {
        getModelsFilter(`brand_${v}`, splitModel(v), ".model");
      });
      $(".model").empty().append(`<span>${window.selectBrand}</span>`);
    });
  }

  function searchFilterInit() {
    //////console.log('searchFilterInit');

    $(document).ready(function () {
      const searchUrl = new URL(window.location.href);
      if (searchUrl.pathname.includes("/search")) {
        const params = searchUrl.searchParams.get("q").split(" ");
        const q = params
          .filter((p) => !p.includes("brand_") && !p.includes("model_"))
          .join(" ");
        getBrands(q);
      } else {
        getBrands();
      }
    });
  }

  function fillSVGInit(d) {
    //////console.log('fillSVGInit');

    checkElement("svg.addFav").then((element) => {
      document.querySelectorAll("svg.addFav").forEach((t) => {
        let dModel1 = t.getAttribute("data-model");
        if (d === dModel1) {
          fillSVG(t, "red");
        }
      });
    });
  }

  function getCurrentFavs() {
    checkElement("svg.delFav") //use whichever selector you want
      .then((element) => {
        document.querySelectorAll("svg.delFav").forEach((t) => {
          let dModel = t.getAttribute("data-model");
          return addHeart(dModel);
        });
      });
  }

  function addHeart(d) {
    checkElement("svg.addFav") //use whichever selector you want
      .then((element) => {
        document.querySelectorAll("svg.addFav").forEach((t) => {
          let dModel1 = t.getAttribute("data-model");
          if (d === dModel1) {
            fillSVG(t, "red");
          }
        });
      });
  }

  const peq = new Uint32Array(0x10000);
  const myers_32 = (a, b) => {
    const n = a.length;
    const m = b.length;
    const lst = 1 << (n - 1);
    let pv = -1;
    let mv = 0;
    let sc = n;
    let i = n;
    while (i--) {
      peq[a.charCodeAt(i)] |= 1 << i;
    }
    for (i = 0; i < m; i++) {
      let eq = peq[b.charCodeAt(i)];
      const xv = eq | mv;
      eq |= ((eq & pv) + pv) ^ pv;
      mv |= ~(eq | pv);
      pv &= eq;
      if (mv & lst) {
        sc++;
      }
      if (pv & lst) {
        sc--;
      }
      mv = (mv << 1) | 1;
      pv = (pv << 1) | ~(xv | mv);
      mv &= xv;
    }
    i = n;
    while (i--) {
      peq[a.charCodeAt(i)] = 0;
    }
    return sc;
  };

  const myers_x = (a, b) => {
    const n = a.length;
    const m = b.length;
    const mhc = [];
    const phc = [];
    const hsize = Math.ceil(n / 32);
    const vsize = Math.ceil(m / 32);
    let score = m;
    for (let i = 0; i < hsize; i++) {
      phc[i] = -1;
      mhc[i] = 0;
    }
    let j = 0;
    for (; j < vsize - 1; j++) {
      let mv = 0;
      let pv = -1;
      const start = j * 32;
      const end = Math.min(32, m) + start;
      for (let k = start; k < end; k++) {
        peq[b.charCodeAt(k)] |= 1 << k;
      }
      score = m;
      for (let i = 0; i < n; i++) {
        const eq = peq[a.charCodeAt(i)];
        const pb = (phc[(i / 32) | 0] >>> i) & 1;
        const mb = (mhc[(i / 32) | 0] >>> i) & 1;
        const xv = eq | mv;
        const xh = ((((eq | mb) & pv) + pv) ^ pv) | eq | mb;
        let ph = mv | ~(xh | pv);
        let mh = pv & xh;
        if ((ph >>> 31) ^ pb) {
          phc[(i / 32) | 0] ^= 1 << i;
        }
        if ((mh >>> 31) ^ mb) {
          mhc[(i / 32) | 0] ^= 1 << i;
        }
        ph = (ph << 1) | pb;
        mh = (mh << 1) | mb;
        pv = mh | ~(xv | ph);
        mv = ph & xv;
      }
      for (let k = start; k < end; k++) {
        peq[b.charCodeAt(k)] = 0;
      }
    }
    let mv = 0;
    let pv = -1;
    const start = j * 32;
    const end = Math.min(32, m - start) + start;
    for (let k = start; k < end; k++) {
      peq[b.charCodeAt(k)] |= 1 << k;
    }
    score = m;
    for (let i = 0; i < n; i++) {
      const eq = peq[a.charCodeAt(i)];
      const pb = (phc[(i / 32) | 0] >>> i) & 1;
      const mb = (mhc[(i / 32) | 0] >>> i) & 1;
      const xv = eq | mv;
      const xh = ((((eq | mb) & pv) + pv) ^ pv) | eq | mb;
      let ph = mv | ~(xh | pv);
      let mh = pv & xh;
      score += (ph >>> (m - 1)) & 1;
      score -= (mh >>> (m - 1)) & 1;
      if ((ph >>> 31) ^ pb) {
        phc[(i / 32) | 0] ^= 1 << i;
      }
      if ((mh >>> 31) ^ mb) {
        mhc[(i / 32) | 0] ^= 1 << i;
      }
      ph = (ph << 1) | pb;
      mh = (mh << 1) | mb;
      pv = mh | ~(xv | ph);
      mv = ph & xv;
    }
    for (let k = start; k < end; k++) {
      peq[b.charCodeAt(k)] = 0;
    }
    return score;
  };

  const distance = (a, b) => {
    if (a.length > b.length) {
      const tmp = b;
      b = a;
      a = tmp;
    }
    if (a.length === 0) {
      return b.length;
    }
    if (a.length <= 32) {
      return myers_32(a, b);
    }
    return myers_x(a, b);
  };

  const closest = (str, arr) => {
    let min_distance = Infinity;
    let min_index = 0;
    for (let i = 0; i < arr.length; i++) {
      const dist = distance(str, arr[i]);
      if (dist < min_distance) {
        min_distance = dist;
        min_index = i;
      }
    }
    return arr[min_index];
  };

  var fastestLevenshtein = {
    closest,
    distance,
  };
  var fastestLevenshtein_1 = fastestLevenshtein.closest;
  var fastestLevenshtein_2 = fastestLevenshtein.distance;

  const levenSort = (query, results) => {
    let q = query.toLowerCase().replace(/\*/g, "");
    const titleTweakFactor = window.titleTweakFactor || 1;
    const tagTweakFactor = window.tagTweakFactor || 1;
    return results.sort((a, b) => {
      if (
        (a.title.toLowerCase() === q ||
          a.title.toLowerCase().includes(q) ||
          a.title
            .toLowerCase()
            .replace(/[\-\s]/g, "")
            .includes(q.replace(/[\-\s]/g, ""))) &&
        !(
          b.title.toLowerCase() === q ||
          b.title.toLowerCase().includes(q) ||
          b.title
            .toLowerCase()
            .replace(/[\-\s]/g, "")
            .includes(q.replace(/[\-\s]/g, ""))
        )
      ) {
        return -1;
      }
      if (
        (b.title.toLowerCase() === q ||
          b.title.toLowerCase().includes(q) ||
          b.title
            .toLowerCase()
            .replace(/[\-\s]/g, "")
            .includes(q.replace(/[\-\s]/g, ""))) &&
        !(
          a.title.toLowerCase().includes(q) ||
          a.title
            .toLowerCase()
            .replace(/[\-\s]/g, "")
            .includes(q.replace(/[\-\s]/g, ""))
        )
      ) {
        return 1;
      }
      // compare to title first
      // multiply by titleTweakFactor
      let aDistance =
        fastestLevenshtein_2(q, a.title.toLowerCase()) * titleTweakFactor;
      let bDistance =
        fastestLevenshtein_2(q, b.title.toLowerCase()) * titleTweakFactor;

      // split query on +
      // compare each query term to each tag
      // multiply by tagTweakFactor
      let qArray = q.split("+");
      qArray.forEach((q) => {
        const aTagDistance =
          fastestLevenshtein_2(
            q.toLowerCase().replace(/[\-\s]/g, ""),
            fastestLevenshtein_1(
              q,
              a.tags.map((t) => t.toLowerCase().replace(/[\-\s]/g, ""))
            )
          ) * tagTweakFactor;
        const bTagDistance =
          fastestLevenshtein_2(
            q,
            fastestLevenshtein_1(
              q.toLowerCase().replace(/[\-\s]/g, ""),
              b.tags.map((t) => t.toLowerCase().replace(/[\-\s]/g, ""))
            )
          ) * tagTweakFactor;
        aDistance = Math.min(aDistance, aTagDistance);
        bDistance = Math.min(bDistance, bTagDistance);
      });
      // return distance
      return bDistance - aDistance;
    });
  };

  function autoSearch() {
    // Current Ajax request.
    var currentAjaxRequest = null;
    // Grabbing all search forms on the page, and adding a .search-results list to each.
    [
      `.drawer__search`,
      `.sticky-only>form.site-header__search`,
      `.site-header__search-cart-wrapper>form.site-header__search`,
      `form[action='${window.searchRoute}'].grid.grid--half-gutters`,
    ].forEach(function (thing) {
      $(thing).each(function () {
        // Grabbing text input.

        var input = $(this).find('input[name="q"]');
        // Adding a list for showing search results.
        var offSet = input.position().top + input.innerHeight();
        if ($(this).hasClass("site-header__search")) {
          $(`<ul class="search-results" style="width:${input.width()}"></ul>`)
            .css({
              position: "fixed",
              top: "unset",
              left: window.innerWidth >= 990 ? "5%" : "1%",
              width:
                window.innerWidth >= 990 ? "calc(90%)" : "calc(98% - 100px)",
            })
            .appendTo($(this))
            .hide();
        } else {
          const rect = this.getBoundingClientRect();
          $(`<ul class="search-results" style="width:${input.width()}"></ul>`)
            .css({
              left: this.classList.contains("drawer__search-input")
                ? window.innerWidth * 0.05 - rect.left
                : window.innerWidth * 0.03 - rect.left,
              top: this.classList.contains("drawer__search-input")
                ? "58px"
                : offSet,
              width:
                window.innerWidth >= 990
                  ? window.innerWidth * 0.9
                  : window.innerWidth * 0.98,
              "margin-left": window.innerWidth >= 990 ? "-5px" : "2px",
              //"max-width": "100%",
            })
            .appendTo($(this))
            .hide();
        }
        // Listening to keyup and change on the text field within these search forms.
        input.attr("autocomplete", "off").bind("keyup change", function () {
          // What's the search term?
          var term = $(this).val() || "";
          term = term
            .split(" ")
            .map((t) => (!t.includes("*") ? `${t}*` : t))
            .join(" ");

          // What's the search form?
          var form = $(this).closest("form");
          // What's the search URL?
          var searchURL = `${window.searchRoute}?type=product&q=${term}*`;
          // What's the search results list?
          var resultsList = form.find(".search-results");
          // If that's a new term and it contains at least 3 characters.
          if (term.length > 1 && term != $(this).attr("data-old-term")) {
            // Saving old query.
            $(this).attr("data-old-term", term);
            // Killing any Ajax request that's currently being processed.
            if (currentAjaxRequest != null) currentAjaxRequest.abort();
            // Pulling results.
            currentAjaxRequest = $.getJSON(
              searchURL + "&view=autocomplete",
              function (data) {
                // Reset results.
                //////console.log(data);
                resultsList.empty();
                // If we have no results.
                if (data.results_count == 0) {
                  resultsList.html(
                    `<li><span class="title full">${window.noResultsString}</span></li>`
                  );
                  resultsList.fadeIn(200);
                  //resultsList.hide();
                } else {
                  // If we have results.
                  // resultsList.append('<li><span class="thumbnail"></span><span class="title">Title</span><span class="title">Price</span><span class="title">Pages</span><span class="title">Cost per page</span></li>');
                  // resultsList.append('<li>')
                  // resultsList.append('<span class="thumbnail"></span>')
                  // resultsList.append('<span class="title">Title</span>')

                  const headingMarkup = `
                  <li>
                  <span class="title thumbnail mobile-hide"></span>
                  <span class="title name">${window.searchTitle}</span>
                  <span class="title center price">${window.priceTitle}</span>
                  <span class="title center pages ">${window.pagesTitle}</span>
                  <span class="title center costperpage ">${window.costPerPageTitle}</span>              
                  </li>
                  `;

                  resultsList.append(headingMarkup);

                  //////console.log(resultsList);
                  //          const sorted = data.results.sort((a,b) => a.title.localeCompare(b.title));
                  const sorted = levenSort(term, data.results);
                  //////console.log(data.results);

                  $.each(sorted, function (index, item) {
                    var link = $("<a></a>").attr("href", item.url);
                    link.append(
                      '<span class="title thumbnail mobile-hide"><img src="' +
                        item.thumbnail +
                        '" /></span>'
                    );
                    link.append(
                      '<span class="title name">' + item.title + "</span>"
                    );
                    //////console.log(item);
                    link.append(
                      `<span class="title price center">${
                        Number(item.price.replace("$", "")) > 0
                          ? `${window.fromString} ${item.price}`
                          : `-`
                      }</span>`
                    );
                    link.append(
                      `<span class="title pages center ">${
                        item.pages === 0 || item.pages === "0"
                          ? "-"
                          : item.pages
                      }</span>`
                    );
                    link.append(
                      `<span class="title costperpage center ">${
                        item.pages === 0 || item.pages === "0"
                          ? "-"
                          : item.costperpage && item.costperpage >= 0.1
                          ? `${
                              window.fromString
                            } ${item.costperpage.toString()}`
                          : "<0.1"
                      }${
                        item.pages === 0 || item.pages === "0" ? "" : "¢"
                      }</span>`
                    );
                    link.wrap("<li></li>");
                    resultsList.append(link.parent());
                  });
                  // The Ajax request will return at the most 10 results.
                  // If there are more than 10, let's link to the search results page.
                  if (data.results_count > 10) {
                    resultsList.append(
                      '<li><span class="title"><a href="' +
                        searchURL +
                        '">See all results (' +
                        data.results_count +
                        ")</a></span></li>"
                    );
                  }
                  $(".drawer").css({ "z-index": 3, overflow: "visible" });
                  $(".drawer__inner").css({ overflow: "visible" });
                  resultsList.fadeIn(200);
                }
              }
            );
          }
        });
      });
    });
    // Clicking outside makes the results disappear.
    $("body").bind("click", function () {
      $(".search-results").hide();
      $(".drawer").css({ "z-index": 1, overflow: "unset" });
      $(".drawer__inner").css({ overflow: "unset" });
    });
  }

  function change(element) {
    if ("createEvent" in document) {
      var evt = document.createEvent("HTMLEvents");
      evt.initEvent("change", false, true);
      element.dispatchEvent(evt);
    } else element.fireEvent("onchange");
  }

  const brandSelectListener = async (ev) => {
    const brandSelect = document.getElementById("brandSelect");
    const modelSelect = document.getElementById("modelSelect");
    const blankModel = document.createElement("option");
    const loadingModel = document.createElement("option");
    modelSelect.innerHTML = "";
    modelSelect.appendChild(loadingModel);
    const indexSearch = document.getElementById("indexSearch");
    indexSearch.value = ev.target.value;
    const models = Object.assign([], await retreiveModels(ev.target.value));
    change(indexSearch);
    modelSelect.innerHTML = "";
    modelSelect.appendChild(blankModel);
    for (const model of models) {
      const modelCapitalized = model.charAt(0).toUpperCase() + model.slice(1);
      let option = document.createElement("option");
      option.value = model;
      option.innerHTML = modelCapitalized.toUpperCase();
      modelSelect.appendChild(option);
    }
    modelSelect.addEventListener("change", async (ev) => {
      const indexSearch = document.getElementById("indexSearch");
      indexSearch.value = `${brandSelect.value} ${ev.target.value}`;
      change(indexSearch);
    });
  };

  async function indexFiltersInit(preload = false) {
    try {
      brandSelect.removeEventListener("change", brandSelectListener);
    } catch (e) {}

    const brands = preload
      ? window.tempBrands.brands
      : (await retreiveBrands()).brands;
    const brandSelect = document.getElementById("brandSelect");
    const modelSelect = document.getElementById("modelSelect");
    const blankModel = document.createElement("option");
    const loadingModel = document.createElement("option");
    blankModel.setAttribute("disabled", "disabled");
    blankModel.setAttribute("selected", "selected");
    blankModel.innerHTML = window.blankString;
    loadingModel.setAttribute("disabled", "disabled");
    loadingModel.setAttribute("selected", "selected");
    loadingModel.innerHTML = window.loadingString;
    if (!preload) {
      brandSelect.innerHTML = "";
      let option = document.createElement("option");
      option.innerHTML = "--";
      option.setAttribute("disabled", "disabled");
      option.setAttribute("selected", "selected");
      brandSelect.appendChild(option);
    }
    for (const brand of brands) {
      const brandClean = brand.replace("brand_", "");
      const brandCapitalized =
        brandClean.charAt(0).toUpperCase() + brandClean.slice(1);
      let option = document.createElement("option");
      option.value = brandClean;
      option.innerHTML = brandCapitalized;
      brandSelect.appendChild(option);
    }
    brandSelect.addEventListener("change", brandSelectListener);
    preload && (await indexFiltersInit(false));
  }

  function addFavListeners(customer) {
    //////console.log("addFavListeners");
    //////console.log("Adding favs");
    document.querySelectorAll("svg.delFav").forEach(function (t) {
      t.addEventListener("click", function (ev) {
        delFav(
          customer,
          t.getAttribute("data-brand"),
          t.getAttribute("data-model")
        );
        removeFillSVG(t.getAttribute("data-model"));
      });
    });
  }

  function productPageFavs() {
    //console.log("productPageFavs");

    var checkExisttest = setInterval(function () {
      let getLocal = JSON.parse(localStorage.favourites);

      const getLocalvalues = getLocal.value;

      if (getLocalvalues != null && getLocalvalues.length) {
        clearInterval(checkExisttest);

        const favs = getLocal;

        const favsValues = getLocalvalues;

        //console.log(favsValues);

        if ($(".compatibles-items").length) {
          var checkExist = setInterval(function () {
            if ($(".wishlist-item").length) {
              clearInterval(checkExist);

              const favsArray = Array.from(
                document.querySelectorAll(".addFav")
              );

              const result = favsArray.filter((e) => {
                favsValues.find((f) => {
                  if (
                    e.getAttribute("data-model").toLowerCase() ==
                      f.model.toLowerCase() &&
                    e.getAttribute("data-brand").toLowerCase() ==
                      f.brand.toLowerCase()
                  ) {
                    e.setAttribute("fill", "red");
                  }
                });
              });

              return result;
            }
          }, 500); // check every 100ms
        } else {
          const favsArray = Array.from(document.querySelectorAll(".addFav"));

          const result = favsArray.filter((e) => {
            favsValues.find((f) => {
              if (
                e.getAttribute("data-model").toLowerCase() ==
                  f.model.toLowerCase() &&
                e.getAttribute("data-brand").toLowerCase() ==
                  f.brand.toLowerCase()
              ) {
                e.setAttribute("fill", "red");
              }
            });
          });
        }
      }
    }, 1000); // check every 100ms
  }

  function loadGridItemsInit() {
    //////console.log("loadGridItemsInit");

    const gridItem = document.querySelectorAll(".grid__item");

    if (gridItem !== null || typeof gridItem !== undefined) {
      gridItem.forEach((evt) => {
        const productCard = evt.querySelector(".product-card__image");
        const productCardImage = evt.querySelector(".main-img");

        const colorSwatch = evt.querySelectorAll("[data-model-color]");

        if (productCardImage !== null) {
          const dataImg = productCardImage.getAttribute("data-img");

          for (let i = 0; i < colorSwatch.length; i++) {
            colorSwatch[i].addEventListener("mouseover", function () {
              for (let sibilings of this.parentNode.children) {
                sibilings.classList.remove("selected");
              }
              this.classList.add("selected");
              const src = this.getAttribute("data-variant-img");

              if (src && src != "") {
                productCardImage.setAttribute("srcset", `${src}`);
              }
            });

            colorSwatch[i].addEventListener("mouseout", function () {
              let cardImage;
              if (!dataImg) {
                cardImage = window.placeHolder;
              } else {
                cardImage = `${window.storeCDN}${dataImg}`;
              }
              productCardImage.setAttribute("srcset", cardImage);
            });
          }
        }
      });
    }
  }

  function productBtnControllerInit() {
    //////console.log("productBtnControllerInit");

    var length = $(".product-item__list li").length;
    //$("#quantity-0").focus();
    $("#submit-table, #buynow-table").click(function (e) {
      e.preventDefault();

      //array for Variant Titles
      var toAdd = new Array();
      for (i = 0; i < length; i++) {
        if ($("#quantity-" + i).val() > 0) {
          toAdd.push({
            variant_id: $("#variant-" + i).val(),
            quantity_id: $("#quantity-" + i).val() || 0,
          });
        }
      }

      function moveAlong() {
        //////console.log(moveAlong);

        if (toAdd.length) {
          var request = toAdd.shift();
          var tempId = request.variant_id;
          var tempQty = request.quantity_id;
          var params = {
            type: "POST",
            url: "/cart/add.js",
            data: "quantity=" + tempQty + "&id=" + tempId,
            dataType: "json",
            success: function (data) {
              $(".notification--success").addClass("notification--active");
              setTimeout(function () {
                $(".notification--success").removeClass("notification--active");
              }, 5000);
              moveAlong();
            },
            error: function () {
              moveAlong();
            },
          };
          $.ajax(params);
        } else {
          $("#mini_cart").load(" #mini_cart > *");
        }
      }
      function toCheckout() {
        if (toAdd.length) {
          var request = toAdd.shift();
          var tempId = request.variant_id;
          var tempQty = request.quantity_id;
          var params = {
            type: "POST",
            url: "/cart/add.js",
            data: "quantity=" + tempQty + "&id=" + tempId,
            dataType: "json",
            success: function (data) {
              ////////console.log("success!");
              toCheckout();
              document.location.href = "/cart/checkout";
            },
            error: function () {
              ////////console.log("fail");
              toCheckout();
            },
          };
          $.ajax(params);
        } else {
          $("#mini_cart").load(" #mini_cart > *");
        }
      }
      $(this).attr("id") == "submit-table" ? moveAlong() : toCheckout();
    });

    $(document).on("click", ".plus__btn", function (e) {
      e.preventDefault();
      var currentVal = parseInt($(this).parent().find(".qty-box").val());
      ////////console.log('plus::' + currentVal);
      if (!isNaN(currentVal)) {
        $(this)
          .parent()
          .find(".qty-box")
          .val(currentVal + 1);
      } else {
        $(this).parent().find(".qty-box").val(0);
      }
    });
    $(document).on("click", ".minus__btn", function (e) {
      e.preventDefault();
      var currentVal = parseInt($(this).parent().find(".qty-box").val());
      ////////console.log('minus::' + currentVal);
      if (!isNaN(currentVal) && currentVal > 0) {
        $(this)
          .parent()
          .find(".qty-box")
          .val(currentVal - 1);
      } else {
        $(this).parent().find(".qty-box").val(0);
      }
    });
    $(document).on("change", ".qty-box", function () {
      var numbers = /^[0-9]+$/;
      var getInputBoxVal = $(this).val();
      if (getInputBoxVal.match(numbers) && getInputBoxVal >= "0") {
        $(this).removeClass("error");
        return true;
      } else {
        $(this).addClass("error");
        $(this).val(0);
        return false;
      }
    });
  }

  function jFeatures() {
    $(".accordion_heading").click(function () {
      $(this).find(".collapse-btn").toggleClass("active");
      $(this).next(".accordion_details").slideToggle();
    });

    $(".filter-tag a").click(function (e) {
      if (e.target.tagName == "INPUT") return true;
      $(this)
        .parents("label")
        .find('input[type="checkbox"]')
        .prop("checked", !$("input[type='checkbox']").prop("checked"));
    });

    $(".sidebar-filter-title").click(function () {
      $(this)
        .find(".toggle-group")
        .toggleClass("sidebar-filter-group-open sidebar-filter-group-close");
      $(this).next(".sidebar-filter-nav").slideToggle();
    });

    $(".filter-toggle-mobile, .close-filter-popup").click(function () {
      $(".grid-collection-filter").toggleClass("filter_small");
      $("body").toggleClass("no-scroll");
    });
  }

  var Ajaxinate = function ajaxinateConstructor(config) {
    var settings = config || {};
    var defaultSettings = {
      pagination: ".AjaxinatePagination",
      method: "scroll",
      container: ".AjaxinateLoop",
      offset: 0,
      loadingText: "Loading",
      callback: null,
    };
    this.settings = Object.assign(defaultSettings, settings);
    this.addScrollListeners = this.addScrollListeners.bind(this);
    this.addClickListener = this.addClickListener.bind(this);
    this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
    this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
    this.destroy = this.destroy.bind(this);
    this.containerElement = document.querySelector(this.settings.container);
    this.paginationElement = document.querySelector(this.settings.pagination);
    this.initialize();
  };
  Ajaxinate.prototype.initialize =
    function initializeTheCorrectFunctionsBasedOnTheMethod() {
      if (this.containerElement) {
        var initializers = {
          click: this.addClickListener,
          scroll: this.addScrollListeners,
        };
        initializers[this.settings.method]();
      }
    };
  Ajaxinate.prototype.addScrollListeners =
    function addEventListenersForScrolling() {
      if (this.paginationElement) {
        document.addEventListener("scroll", this.checkIfPaginationInView);
        window.addEventListener("resize", this.checkIfPaginationInView);
        window.addEventListener(
          "orientationchange",
          this.checkIfPaginationInView
        );
      }
    };
  Ajaxinate.prototype.addClickListener =
    function addEventListenerForClicking() {
      if (this.paginationElement) {
        this.nextPageLinkElement = this.paginationElement.querySelector("a");
        this.clickActive = true;
        if (this.nextPageLinkElement !== null) {
          this.nextPageLinkElement.addEventListener(
            "click",
            this.stopMultipleClicks
          );
        }
      }
    };
  Ajaxinate.prototype.stopMultipleClicks = function handleClickEvent(event) {
    event.preventDefault();
    if (this.clickActive) {
      this.nextPageLinkElement.innerHTML = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.clickActive = false;
      this.loadMore();
    }
  };
  Ajaxinate.prototype.checkIfPaginationInView = function handleScrollEvent() {
    var top =
      this.paginationElement.getBoundingClientRect().top - this.settings.offset;
    var bottom =
      this.paginationElement.getBoundingClientRect().bottom +
      this.settings.offset;
    if (top <= window.innerHeight && bottom >= 0) {
      this.nextPageLinkElement = this.paginationElement.querySelector("a");
      this.removeScrollListener();
      if (this.nextPageLinkElement) {
        this.nextPageLinkElement.innerHTML = this.settings.loadingText;
        this.nextPageUrl = this.nextPageLinkElement.href;
        this.loadMore();
      }
    }
  };
  Ajaxinate.prototype.loadMore =
    function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
      this.request = new XMLHttpRequest();
      this.request.onreadystatechange = function success() {
        if (this.request.readyState === 4 && this.request.status === 200) {
          var newContainer = this.request.responseXML.querySelectorAll(
            this.settings.container
          )[0];
          var newPagination = this.request.responseXML.querySelectorAll(
            this.settings.pagination
          )[0];
          this.containerElement.insertAdjacentHTML(
            "beforeend",
            newContainer.innerHTML
          );
          this.paginationElement.innerHTML = newPagination.innerHTML;
          if (
            this.settings.callback &&
            typeof this.settings.callback === "function"
          ) {
            this.settings.callback(this.request.responseXML);
          }
          this.initialize();
        }
      }.bind(this);
      this.request.open("GET", this.nextPageUrl);
      this.request.responseType = "document";
      this.request.send();
    };
  Ajaxinate.prototype.removeClickListener =
    function removeClickEventListener() {
      this.nextPageLinkElement.addEventListener(
        "click",
        this.stopMultipleClicks
      );
    };
  Ajaxinate.prototype.removeScrollListener =
    function removeScrollEventListener() {
      document.removeEventListener("scroll", this.checkIfPaginationInView);
      window.removeEventListener("resize", this.checkIfPaginationInView);
      window.removeEventListener(
        "orientationchange",
        this.checkIfPaginationInView
      );
    };
  Ajaxinate.prototype.destroy = function removeEventListenersAndReturnThis() {
    var destroyers = {
      click: this.removeClickListener,
      scroll: this.removeScrollListener,
    };
    destroyers[this.settings.method]();
    return this;
  };

  const retBrands = () => retreiveBrands();
  const retModels = (brand) => retreiveModels(brand);
  const indexInit = (preload) => indexFiltersInit(preload);
  const currentFavs = () => getCurrentFavs();

  const favDelListeners = () => addFavListeners();
  const favAddListeners = (customer) => listen(customer);
  const loadFavs = (customer) => getFavs(customer);
  const loadActiveProductFavs = () => productPageFavs();
  const loadGridItems = () => loadGridItemsInit();
  const productBtnController = () => productBtnControllerInit();
  const jFeaturesInit = () => jFeatures();

  async function displayFavourites(customer, favs = null) {
    displayFavouritesInit(customer, (favs = null));
    fillSVGInit();
  }

  /**
   * Run this function if template contains collection
   */
  function initCollection() {
    // Do somethings before the init like get current favs to make red
    collectionFilterInit();
    loadGridItemsInit();
  }

  function initSearch() {
    // Do somethings before the init like get current favs to make red
    searchFilterInit();
    searchFilterInit();
    loadGridItemsInit();
  }

  document.addEventListener("DOMContentLoaded", (event) => {
    setTimeout(() => {
      var endlessScroll = new Ajaxinate({
        container: "#CC-Loop",
        pagination: "#CC-Pagination",
      });
      autoSearch();
      getCurrentFavs();
      jFeaturesInit();
      productBtnController();
    }, 100);
  });

  exports.currentFavs = currentFavs;
  exports.displayFavourites = displayFavourites;
  exports.favAddListeners = favAddListeners;
  exports.favDelListeners = favDelListeners;
  exports.indexInit = indexInit;
  exports.initCollection = initCollection;
  exports.initSearch = initSearch;
  exports.jFeaturesInit = jFeaturesInit;
  exports.loadActiveProductFavs = loadActiveProductFavs;
  exports.loadFavs = loadFavs;
  exports.loadGridItems = loadGridItems;
  exports.productBtnController = productBtnController;
  exports.retBrands = retBrands;
  exports.retModels = retModels;

  Object.defineProperty(exports, "__esModule", { value: true });
});
